const apiUri = path => path.substring(0, 8) === 'https://' ? path : `${process.env.VUE_APP_API_URI}${path}`;

module.exports = {
    apiUri,
};
